import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { VisualizarOgp6Page } from './visualizar-ogp6.page';

const routes: Routes = [
  {
    path: '',
    component: VisualizarOgp6Page
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [VisualizarOgp6Page]
})
export class VisualizarOgp6PageModule {}
